const domainTag = 'frontend_portal_';

const portalBooleanFlagNames = ['menuV3_enableQa', 'authz_integration'] as const;

type PortalBooleanFlagName = (typeof portalBooleanFlagNames)[number];

export type PortalBooleanFlagKey = `${typeof domainTag}${PortalBooleanFlagName}`;

type PortalBooleanFlagKeysShape = {
  readonly [Name in PortalBooleanFlagName]: `${typeof domainTag}${Name}`;
};

export const PortalBooleanFlagKeys = Object.fromEntries(
  portalBooleanFlagNames.map((name) => [name, `${domainTag}${name}`])
) as PortalBooleanFlagKeysShape;
